import { FaLock } from "react-icons/fa";
const AccessDenied = () => {
    return (
        <div className="container mt-80 access-denied">
            <FaLock fontSize={48} />
            <h3>Access to this page is restricted</h3>
            <p>Please ask the site admin if you believe this is a mistake</p>
        </div>
    )
}
export default AccessDenied;